import { render, staticRenderFns } from "./aboutContact.vue?vue&type=template&id=5b1c3219&scoped=true"
import script from "./aboutContact.vue?vue&type=script&lang=js"
export * from "./aboutContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c3219",
  null
  
)

export default component.exports